import React, { useEffect, useState } from "react";
import Loader from "react-loaders";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import edLogo from "../../assets/images/Edoozo.png";
import tsfLogo from "../../assets/images/tsf.png";
import vlaLogo from "../../assets/images/VictoryLawAssociates.png";
import NvLogo from "../../assets/images/logo.png";

const data = [
  {
    cover: edLogo,
    title: "Edoozo Web",
    description:
      "Developed and launched a high-performance WordPress website on GoDaddy.",
    url: "https://edoozo.com/",
  },
  {
    cover: tsfLogo,
    title: "The Study Falcon Web App",
    description:
      "Developed dynamic, responsive web interfaces with React.js. Managed backend development with Node.js and MySQL, deployed on Azure, and handled domain on GoDaddy.",
    url: "http://thestudyfalcon.com",
  },
  {
    cover: vlaLogo,
    title: "Victory Law Associates",
    description:
      "Developed a high-performance WordPress website for a law firm on GoDaddy, using MySQL for the database and PHP for the backend.",
    url: "http://victoryasso.com",
  },
  {
    cover: NvLogo,
    title: "NumoUsha Web",
    description:
      "Developed static, responsive web interfaces with React.js. Deployed on Azure, and handled domain on GoDaddy.",
    url: "http://numousha.com/",
  },
  {
    cover: edLogo,
    title: "Edoozo App",
    description:
      "Engineered a Native app, established a backend with Node.js, managed a PostgreSQL database, and deployed on PlayStore for public use.",
    url: "https://play.google.com/store/apps/details?id=com.edoozo&pcampaignid=web_share",
  },
  {
    cover: tsfLogo,
    title: "The Study Falcon App",
    description:
      "Built a seamless cross-platform mobile app using React Native. Managed backend development with Node.js and MySQL, deployed on Azure, and deployed on PlayStore for public use.",
    url: "https://play.google.com/store/apps/details?id=com.studyfalcon&pcampaignid=web_share",
  },
  {
    cover: NvLogo,
    title: "NumoUsha App",
    description:
      "Developed a React-Native Mobile Application for Numerologists to generate required charts and other related aspects.",
    url: "https://drive.google.com/file/d/15x-B4PlE6cIOMAsQFlfCWkenJxeR-z_g/view?usp=drive_link",
  },
];

const Portfolio = () => {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  });

  const RenderPortfolio = () => {
    return (
      <div className="images-container">
        {data.map((port, idx) => {
          const { cover, title, description, url } = port;
          return (
            <div className="image-box" key={idx}>
              <img src={cover} className="portfolio-image" alt="portfolio" />
              <div className="content">
                <p className="title">{title}</p>
                <p className="description">{description}</p>
                <br />
                <button className="btn" onClick={() => window.open(url)}>
                  View
                </button>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <>
      <div className="container portfolio-page">
        <h1 className="page-title">
          <AnimatedLetters
            letterClass={letterClass}
            strArray={"My Projects".split("")}
            idx={15}
          />
        </h1>
        <div>
          <RenderPortfolio />
        </div>
      </div>
      <Loader type="pacman" />
    </>
  );
};

export default Portfolio;
